import 'magnific-popup'
import Block from '../../../../_base/src/components/block'

export default class BlockThumbnail extends Block {
	static title = 'block-thumbnail'

	constructor($el) {
		super($el)

		this.images = this.$el.find('.block-thumbnail__image')
		this.images.removeClass('block-thumbnail__image--loading')

		let section = null
		if (this.$el.data('background')) {
			section = this.$el.data('background').split('-')[1]
		}

		this.images.magnificPopup({
			type: 'image',
			gallery: {
				enabled: true,
				navigationByImageClick: true,
				preload: [0, 1],
			},
			allowHTMLInTemplate: true,
			showCloseBtn: false,
			image: {
				markup: section
					? '<div class="mfp-figure section-' +
					  section +
					  '">' +
					  '<div class="mfp-close"><i class="fa-regular fa-xmark"></i></div>' +
					  '<div class="mfp-img"></div>' +
					  '<div class="mfp-bottom-bar">' +
					  '<div class="mfp-title"></div>' +
					  '</div>' +
					  '</div>'
					: '<div class="mfp-figure">' +
					  '<div class="mfp-close"><i class="fa-regular fa-xmark"></i></div>' +
					  '<div class="mfp-img"></div>' +
					  '<div class="mfp-bottom-bar">' +
					  '<div class="mfp-title"></div>' +
					  '</div>' +
					  '</div>',

				titleSrc: function (item) {
					if (!item.el.attr('title') && !item.el.attr('description')) {
						return null
					}

					return (
						'<div class="mfp-title-container">' +
						'<div class="mfp-title-bar"></div>' +
						'<div class="mfp-title-text">' +
						item.el.attr('title') +
						'</div>' +
						'<div class="mfp-title-description">' +
						item.el.attr('description') +
						'</div>' +
						'</div>'
					)
				},
			},

			tLoading: `Loading...`,

			callbacks: {
				change: (el) => {
					this.isLoaded(el)
				},
				open: () => {
					$('.mfp-bg').addClass('section-' + section)
				},
			},
		})

		// The lightbox is a singleton, so one listener serves every block; rAF keeps a drag to one pass per frame.
		if (!BlockThumbnail.resizeBound) {
			BlockThumbnail.resizeBound = true

			let frame = null

			window.addEventListener('resize', () => {
				if (frame) {
					return
				}

				frame = window.requestAnimationFrame(() => {
					frame = null

					// a jQuery object is truthy even when empty, so check length
					const mfpImg = $('.mfp-img')

					if (mfpImg.length) {
						this.clickedImage = { img: mfpImg }
						this.changeStyling(this.clickedImage)
					}
				})
			})
		}
	}

	isLoaded(image) {
		setTimeout(() => {
			if (
				image.loaded &&
				!image.isCheckingImgSize &&
				image.img.is(':visible')
			) {
				this.changeStyling(image)
			} else {
				this.isLoaded(image)
			}
		}, 100)
	}

	changeStyling(el) {
		$('.mfp-arrow-left').css(
			'left',
			el.img.get(0).getBoundingClientRect().left - 32,
		)
		$('.mfp-arrow-right').css(
			'left',
			el.img.get(0).getBoundingClientRect().right - 32,
		)
		$('.mfp-bottom-bar').css('width', el.img.width())
	}
}
